import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectUser } from "../../auth/auth.selector";
import IssueTypes from "./IssueTypes";
import Categories from "./Categories";
import SubCategories from "./SubCategories";
import "./ticket-management.css";

const TicketSystemManagement = () => {
  const userInfoData = useSelector(selectUser);
  const [activeTab, setActiveTab] = useState("issueTypes");
  const [selectedIssueType, setSelectedIssueType] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const tabs = [
    { id: "issueTypes", label: "Issue Types", component: IssueTypes },
    { id: "categories", label: "Categories", component: Categories },
    { id: "subCategories", label: "Sub Categories", component: SubCategories },
  ];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);

    // Reset selections when going back to previous levels
    if (tabId === "issueTypes") {
      setSelectedIssueType(null);
      setSelectedCategory(null);
    } else if (tabId === "categories") {
      setSelectedCategory(null);
    }
  };

  const handleIssueTypeSelect = (issueType) => {
    setSelectedIssueType(issueType);
    setSelectedCategory(null);
    setActiveTab("categories");
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setActiveTab("subCategories");
  };

  const getCurrentComponent = () => {
    const tab = tabs.find((t) => t.id === activeTab);
    if (!tab) return null;

    const Component = tab.component;
    return (
      <Component
        token={userInfoData?.token}
        selectedIssueType={selectedIssueType}
        selectedCategory={selectedCategory}
        onIssueTypeSelect={handleIssueTypeSelect}
        onCategorySelect={handleCategorySelect}
        setSelectedIssueType={setSelectedIssueType}
        setSelectedCategory={setSelectedCategory}
      />
    );
  };

  return (
    <div className="ticket-system-management">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <div className="ticket-management-header">
              <h2 className="page-heading">Ticket System Management</h2>
              <p className="page-description">
                Manage issue types, categories, and sub categories for the
                ticket system
              </p>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="tab-container">
              <div className="tab-header">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    className={`tab-button ${
                      activeTab === tab.id ? "active" : ""
                    }`}
                    onClick={() => handleTabChange(tab.id)}
                  >
                    {tab.label}
                    {tab.id === "categories" && selectedIssueType && (
                      <span className="tab-badge">
                        {selectedIssueType.name}
                      </span>
                    )}
                    {tab.id === "subCategories" && selectedCategory && (
                      <span className="tab-badge">{selectedCategory.name}</span>
                    )}
                  </button>
                ))}
              </div>

              <div className="tab-content">{getCurrentComponent()}</div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TicketSystemManagement;
